<template>
  <div class="not-started-container flexbox" style="height: 100%">
    <div class="not-started-box">
      <div class="not-started-header"></div>
      <div class="not-started-body">
        <count-down :etime="data.stime">
          <h5 class="not-started-title">距离活动开始还有</h5>
        </count-down>
      </div>
      <div class="not-started-footer" @click="goBack">我知道啦</div>
    </div>
  </div>
</template>

<script>
import { WebBridgeApi } from "ijsbridge";
import CountDown from "./CountDown";
export default {
  name: "",
  props: {
    data: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {

    }
  },
  components: {
    CountDown
  },
  computed: {},
  methods: {
    goBack() {
      WebBridgeApi.router({
        route: "back",
      });
    },
  },
  created() {
  },
  watch: {}
}
</script>

<style scoped lang="less">
.not-started-container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9999;

  .not-started-box {
    width: 85%;

    .not-started-header {
      height: 0.99rem;
      background: transparent url(../assets/images/top-bg.png) center top no-repeat;
      background-size: 100%;
    }

    .not-started-body {
      width: 100%;
      background: #fff;
      display: flex;
      align-items: center;

      .not-started-title {
        font-size: 0.36rem;
        color: #666;
        text-align: center;
      }
    }

    .not-started-footer {
      background: #fff;
      height: 0.92rem;
      line-height: 0.92rem;
      text-align: center;
      font-size: 0.32rem;
      color: #999;
      border-bottom-left-radius: 0.3rem;
      border-bottom-right-radius: 0.3rem;
      border-top: 0.01rem solid #e6e5e6;
    }
  }
}
</style>